/* KieroKombucha theme — JS mínimo (sin apps nuevas, sin frameworks) */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    var close = document.querySelector('[data-nav-close]');
    if (!toggle || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', openDrawer);
    if (close) close.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // --- Cross-sell: Product Recommendations API nativa de Shopify ---
    var rec = document.querySelector('[data-recommendations]');
    if (rec) {
      var url = rec.getAttribute('data-url');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim() !== '') rec.replaceWith(fresh);
        })
        .catch(function () { /* si falla, simplemente no se muestra el bloque */ });
    }
  });
})();
